var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoseUsBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 729,
    viewBox: "0 0 293 729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -94.2035,
    cy: 355.814,
    r: 241.622,
    transform: "rotate(54.9495 -94.2035 355.814)",
    stroke: "#EDD569",
    strokeWidth: 3.2036
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -46.1957,
    cy: 372.65,
    r: 241.622,
    transform: "rotate(54.9495 -46.1957 372.65)",
    stroke: "#EDD569",
    strokeWidth: 3.2036
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoseUsBgImg);
export default __webpack_public_path__ + "static/media/choseUsBgImg.7ec92dcc86abb7c0dd5b521b3c64f184.svg";
export { ForwardRef as ReactComponent };